import { render, staticRenderFns } from "./UserMobile.vue?vue&type=template&id=01a1e5f9&"
import script from "./UserMobile.vue?vue&type=script&lang=js&"
export * from "./UserMobile.vue?vue&type=script&lang=js&"
import style0 from "./UserMobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports